module.exports = __webpack_public_path__ + "static/media/products-image-5.96499e45.jpg";